export default {
    select: "选择送货地址",
    shippingRulesTip: "您必须遵守当地的运输规则"
}